import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';

// Rotating social-proof toasts shown while the acquisition prompt is visible.
// Non-blocking, subtle, one at a time, well-spaced.
const MESSAGES = [
  'Rahul just claimed 7 days of free access',
  'Moksha just started the free challenges',
  'Ananya just unlocked her Brain Report',
  'Arjun just claimed free access',
  'Priya just started her brain challenges',
  'Vihaan just claimed 7 days of free access',
  'Meera just unlocked her Brain Report',
  'Kabir just started the free challenges',
  'Diya just claimed free access',
  'Ishaan just started her brain challenges',
];

const VISIBLE_MS = 4200;
const GAP_MS = 5000;

const SocialProofToasts = ({ active }) => {
  const [idx, setIdx] = useState(0);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!active) { setShown(false); return; }
    let cancelled = false;
    const cycle = async () => {
      // initial delay so the modal has time to render
      await new Promise((r) => setTimeout(r, 1800));
      while (!cancelled) {
        setShown(true);
        await new Promise((r) => setTimeout(r, VISIBLE_MS));
        if (cancelled) return;
        setShown(false);
        await new Promise((r) => setTimeout(r, 400)); // fade out
        if (cancelled) return;
        setIdx((i) => (i + 1) % MESSAGES.length);
        await new Promise((r) => setTimeout(r, GAP_MS - 400));
      }
    };
    cycle();
    return () => { cancelled = true; };
  }, [active]);

  if (!active) return null;

  return (
    <div
      data-testid="social-proof-toast"
      aria-live="polite"
      className={`pointer-events-none fixed left-4 right-4 sm:left-6 sm:right-auto bottom-4 sm:bottom-6 z-[60] transition-all duration-400 ${
        shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}
    >
      <div className="mx-auto sm:mx-0 max-w-xs rounded-2xl bg-[#3D2817]/95 border border-[#F4C430]/30 backdrop-blur px-3.5 py-2.5 shadow-[0_20px_40px_-20px_rgba(0,0,0,0.7)] flex items-center gap-2.5">
        <div className="h-7 w-7 rounded-full grid place-items-center bg-[#F4C430]/20 border border-[#F4C430]/50 shrink-0">
          <CheckCircle2 className="text-[#F4C430]" size={14} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[13px] text-[#F5EDE0] truncate">{MESSAGES[idx]}</div>
          <div className="text-[10px] text-[#B8A990]">Recent activity</div>
        </div>
      </div>
    </div>
  );
};

export default SocialProofToasts;
